import { BrowserRouter, Route,  Routes,  } from 'react-router-dom';
import './App.css';
import Lieferschein from './lieferschein/lieferschein';
import Liste from './liste/liste';
import Login from './login/login';
import Menu from './menu/menu';
import Error from './error/error';
import Rechnung from './rechnung/rechnung';
import ListeRechnung from './listeRechnung/listeRechnung';
import Kunden from './kunden/kunden';
import ListeKunden from './kunden/listeKunde';
import Zeit from './zeit/zeit';
import ZeitListe from './zeit/zeitListe';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        
        <Route path='/ls' element={<Lieferschein  />} />
        <Route path='/ls/:id' element={<Lieferschein  />} />
        <Route path='/list' element={<Liste />} />
        <Route path='/rg' element={<Rechnung  />} />
        <Route path='/rg/:id' element={<Rechnung  />} />
        <Route path='/lsrg' element={<ListeRechnung />} />
        <Route path='/login' element={<Login />} />
        <Route path='/error' element={<Error />} />
        <Route path='/kunden' element={<Kunden />} />
        <Route path='/kunden/:id' element={<Kunden />} />
        <Route path='/lsKunden' element={<ListeKunden />} />
        <Route path='/zeit' element={<Zeit />} />
        <Route path='/zeitliste' element={<ZeitListe />} />
        <Route index path='/*' element={<Menu  />} />
      </Routes>
    </BrowserRouter>

  );
}

export default App;
